import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { TIMEOUT_AXIOS_REQUEST } from 'common/constants';
import { store } from 'v3/data/store';
import { decrementLoadingCount, incrementLoadingCount } from 'v3/data/store/loading/actions';
import { CreditSimulationOriginEnum } from 'v3/data/store/onlineContracting/enums';
import { setCookiesToHeaders } from 'v3/services/utils/set-cookies-to-headers';

const IS_PROXY = import.meta.env.VITE_IS_PROXY === 'true';

const createOnlineApiClient = (baseURL: string): AxiosInstance => {
  const client = axios.create({
    baseURL,
    timeout: TIMEOUT_AXIOS_REQUEST,
  });

  client.interceptors.response.use(
    (response: AxiosResponse) => {
      if (!response.config.metadata?.bypassLoading) decrementLoadingCount();
      return response;
    },
    (error) => {
      if (!error.config?.metadata?.bypassLoading) decrementLoadingCount();
      return Promise.reject(error);
    },
  );

  client.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const { storeUserId } = store.getState().store.storeSelected;
      config.headers['storeId'] = storeUserId;
      const bypassLoading = Boolean(config.headers?.['x-bypass-loading']);
      config.metadata = { bypassLoading };

      if (!bypassLoading) {
        incrementLoadingCount();
      }
      return setCookiesToHeaders(config);
    },
    (error) => {
      if (!error.config?.metadata?.bypassLoading) decrementLoadingCount();
      return Promise.reject(error);
    },
  );

  return client;
};

const onlineApi = createOnlineApiClient(
  IS_PROXY ? import.meta.env.VITE_IN_APP_API_BASE_URL_PROXY_REVERSE : import.meta.env.VITE_IN_APP_API_BASE_URL,
);

export const onlineLomApi = createOnlineApiClient(
  IS_PROXY ? import.meta.env.VITE_LOM_API_BASE_URL_PROXY_REVERSE : import.meta.env.VITE_LOM_API_BASE_URL,
);

export const getOnlineApiClient = (origin?: string): AxiosInstance => {
  return origin === CreditSimulationOriginEnum.LOM ? onlineLomApi : onlineApi;
};

export default onlineApi;
